import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import FocusScroll from '../../FocusScroll';
import styles from './FormError.css';

const FormError = ({ error, style, className, focus, ...props }) => (error ? <div
    className={cx(styles.error, className)}
    style={style}
    role="alert"
    aria-live="assertive"
    {...props}
>
    {focus ? <FocusScroll /> : null}
    {error}
</div> : null);

FormError.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    style: PropTypes.object,
    className: PropTypes.string,
    focus: PropTypes.bool,
};

export default FormError;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/FormError/FormError.js